import React, { useContext, useState, useEffect, useRef } from "react";
import { PatentContext } from "../context/PatentContextProvider";
import axios from "axios";
import { io } from "socket.io-client";
import Loader from "./ChatLoader";
import { FaPlay, FaPause } from "react-icons/fa";

const Bot = ({ closeChat, name }) => {
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState("");
  const [userId, setUserId] = useState("");
  const [email, setEmail] = useState(sessionStorage.getItem('email') || '');
  const { selectedPatent } = useContext(PatentContext);
  const [loading, setLoading] = useState(false);
  const messageEndRef = useRef(null); // Create a ref to scroll to the latest message
  const chatRef = useRef(null);
  const [speakingIndex, setSpeakingIndex] = useState(null);
  const [isExpanded, setIsExpanded] = useState(false);
  const synthRef = useRef(window.speechSynthesis);
  const [, forceUpdate] = useState(0); // for immediate UI update
  const speakingRef = useRef(null);    // track current speaking message
  const utteranceRef = useRef(null);
  const chunkIndexRef = useRef(0);     // current chunk index for long messages
  const chunkArrayRef = useRef([]);  



  // ✅ NEW: expand/shrink state

  // Destructure patent details from selectedPatent
  const {
  } = selectedPatent;

  const splitTextIntoChunks = (text, maxLength = 2000) => {
    // split into sentences first
    const sentences = text.match(/[^.!?]+[.!?]?/g) || [text];
    const chunks = [];
    let currentChunk = "";

    sentences.forEach((s) => {
      if ((currentChunk + s).length > maxLength) {
        chunks.push(currentChunk);
        currentChunk = s;
      } else {
        currentChunk += s;
      }
    });
    if (currentChunk) chunks.push(currentChunk);
    return chunks;
  };

 const speakChunk = (index) => {
  if (chunkIndexRef.current >= chunkArrayRef.current.length || speakingRef.current !== index) {
    speakingRef.current = null;
    chunkIndexRef.current = 0;
    chunkArrayRef.current = [];
    forceUpdate((n) => n + 1);
    return;
  }

  const utterance = new SpeechSynthesisUtterance(chunkArrayRef.current[chunkIndexRef.current]);
  utteranceRef.current = utterance;

  utterance.onend = () => {
    chunkIndexRef.current++;

    // small delay before next chunk to avoid browser cutoff
    setTimeout(() => {
      speakChunk(index);
    }, 100); // 100ms delay
  };

  window.speechSynthesis.speak(utterance);
};

  const handlePlayPause = (text, index) => {
    const synth = window.speechSynthesis;
    if (!synth) return;

    // If same message is playing, stop it
    if (speakingRef.current === index) {
      synth.cancel();
      speakingRef.current = null;
      chunkIndexRef.current = 0;
      chunkArrayRef.current = [];
      forceUpdate((n) => n + 1);
      return;
    }

    // Stop previous speech
    synth.cancel();

    // Split text into chunks if long
    chunkArrayRef.current = splitTextIntoChunks(text);
    chunkIndexRef.current = 0;
    speakingRef.current = index;
    forceUpdate((n) => n + 1);

    speakChunk(index);
  };

  useEffect(() => {
    let storedUserId = sessionStorage.getItem("userId");
    if (!storedUserId) {
      storedUserId = crypto.randomUUID(); // or use uuid library
      sessionStorage.setItem("userId", storedUserId);
    }
    setUserId(storedUserId);
  }, [])

useEffect(() => {
    const email = sessionStorage.getItem('email');
    if (!email) return;
    const socket = io("http://localhost:3000", {
      auth: { email },
      transports: ['websocket'],
      path: "/socket.io/",
      closeOnBeforeunload: false // Crucial for proper cleanup
    });

    // 2. Backup API Trigger (Secondary Method)
    const triggerExitApi = async () => {
      try {
        await fetch(`${process.env.REACT_APP_API_PATH}/user-exit`, {
          method: 'POST',
          body: JSON.stringify({ email }),
          headers: { 'Content-Type': 'application/json' },
          keepalive: true // Ensures request completes during page termination
        });
      } catch (error) {
        console.error('Exit API error:', error);
      }
    };

    // 3. Handle Tab/Browser Close
    const handleWindowClose = () => {
      // If WebSocket is connected, it will auto-detect disconnect
      if (!socket.connected) {
        triggerExitApi(); // Fallback if WebSocket failed
      }
    };

    // 4. Set Up Event Listeners
    window.addEventListener('pagehide', handleWindowClose); // Most reliable for closes
    window.addEventListener('beforeunload', handleWindowClose); // Backup

    return () => {
      // Cleanup on component unmount (not page close)
      socket.disconnect();
      window.removeEventListener('pagehide', handleWindowClose);
      window.removeEventListener('beforeunload', handleWindowClose);
    };
  }, []);

  useEffect(() => {
    function handleClickOutside(event) {
      if (chatRef.current && !chatRef.current.contains(event.target)) {
        closeChat();
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside)
    }
  }, [])

  useEffect(() => {
    setEmail(sessionStorage.getItem("email"))
  }, [messages])

  // Scroll to the latest message
  const scrollToBottom = () => {
    if (messageEndRef.current) {
      messageEndRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  // ✅ Scroll again when expanding/shrinking so newest message stays in view
  useEffect(() => {
    scrollToBottom();
  }, [isExpanded]);

  // Format the AI response to remove unwanted symbols
  const formatResponse = (response) => {
    return response.replace(/[*_~`]/g, "").trim();
  };


  const sendMessage = async () => {
    if (!input) return;

    const newMessages = [...messages, { text: input, sender: "user" }];
    setMessages(newMessages);
    setInput("");
    setLoading(true);

    const lastAIMessage = messages[messages.length - 1]?.text;

    // If AI asked for email
    if (lastAIMessage?.includes("Please enter your email address")) {
      if (input.includes("@")) {
        sessionStorage.setItem("email", input); // ✅ Save to session

        // 👇 Get email again from session (important!)
        const emailInStorage = sessionStorage.getItem("email");

        // 👇 Now send to backend
        const response = await getAIResponse(input, emailInStorage);
        const formattedResponse = formatResponse(response);

        setMessages([...newMessages, { text: formattedResponse, sender: "ai" }]);
        // resetHeight();
        setLoading(false);
        scrollToBottom();
        return;
      } else {
        setMessages([
          ...newMessages,
          { text: "❌ Invalid email. Please try again.", sender: "ai" },
        ]);
        setLoading(false);
        scrollToBottom();
        return;
      }
    }

    // 👇 For regular questions (after email is already stored)
    const emailInStorage = sessionStorage.getItem("email");
    setEmail(sessionStorage.getItem("email"))
    const response = await getAIResponse(input, emailInStorage);
    const formattedResponse = formatResponse(response);

    setMessages([...newMessages, { text: formattedResponse, sender: "ai" }]);
    // resetHeight();
    setLoading(false);
    scrollToBottom();
  };

  useEffect(() => {
    const email = sessionStorage.getItem("email");
    const getPreviousQuestions = async () => {

      if (email) {
        try {
          const response = await axios.post(`${process.env.REACT_APP_API_PATH}/chatBot`, {
            email
          })
          const aiResponse = response.data.getResponse.data?.response?.candidates[0]?.content.parts[0]?.text;
          const formattedResponse = formatResponse(aiResponse);
          setMessages([{ text: formattedResponse, sender: "ai" }])


        } catch (err) {
          console.log('err', err)
        }

      }
    }
    getPreviousQuestions()

  }, [])

  useEffect(() => {
    const getGreetingResponse = async () => {
      const isEmail = sessionStorage.getItem("email");
      if (!isEmail) {
        const isChatBotOpen = true
        const getResponse = await axios.post(
          `${process.env.REACT_APP_API_PATH}/getContent`,
          {
            userId: userId,
            isChatBotOpen
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        // console.log('getResponse', getResponse.data.getResponse.data.response.candidates[0]?.content?.parts[0].text);
        const aiResponse =
          getResponse?.data?.response?.candidates?.[0]?.content?.parts?.[0]?.text ||
          getResponse?.data?.getResponse?.data?.response?.candidates?.[0]?.content?.parts?.[0]?.text;
        const formattedResponse = formatResponse(aiResponse);
        setMessages([{ text: formattedResponse, sender: "ai" }]);
        return aiResponse;
      }

    }
    getGreetingResponse()
  }, [])

  const getAIResponse = async (userInput, email) => {
    try {
      const response = await fetchGeminiAI(userInput, email);
      return response;
    } catch (error) {
      return "Sorry, something went wrong.";
    }
  };

  const fetchGeminiAI = async (prompt, email) => {
    try {
      if (name) {
        const getResponse = await axios.post(`${process.env.REACT_APP_API_PATH}/getUserContent`,
          {
            name,
            prompt: prompt,
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        const aiResponse = getResponse.data.response.candidates[0]?.content?.parts[0].text;
        return aiResponse;
      } else {
        const getResponse = await axios.post(
          `${process.env.REACT_APP_API_PATH}/getContent`,
          {
            prompt: prompt,
            userId: userId,
            email

          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        // console.log('getResponse', getResponse.data.getResponse.data.response.candidates[0]?.content?.parts[0].text);
        const aiResponse =
          getResponse?.data?.response?.candidates?.[0]?.content?.parts?.[0]?.text ||
          getResponse?.data?.getResponse?.data?.response?.candidates?.[0]?.content?.parts?.[0]?.text;

        return aiResponse;
      }
    } catch (error) {
      console.error("Error:", error.message);
      return "Sorry, something went wrong.";
    }
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  return (
    <div
      ref={chatRef}
      className="fixed z-50 bottom-0 right-0 md:right-6 md:bottom-6 w-[50%] w-[25rem] rounded-2xl shadow-2xl border border-white/20 bg-white/70 backdrop-blur-xl overflow-hidden animate-[fadeInUp_0.3s_ease-out]"
    >
      {/* Header */}
      <div className="p-4 bg-gradient-to-r from-blue-500 to-indigo-500 flex items-center justify-between shadow-md">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-full bg-white/20 flex items-center justify-center">
            <svg
              className="w-6 h-6 text-white"
              xmlns="http://www.w3.org/2000/svg"
              fill="currentColor"
              viewBox="0 0 24 24"
            >
              <circle cx="12" cy="12" r="1"></circle>
              <circle cx="16" cy="12" r="1"></circle>
              <circle cx="8" cy="12" r="1"></circle>
              <path d="M19.07 4.93a10 10 0 0 0-16.28 11 1.06 1.06 0 0 1 .09.64L2 20.8a1 1 0 0 0 .27.91A1 1 0 0 0 3 22h.2l4.28-.86a1.26 1.26 0 0 1 .64.09 10 10 0 0 0 11-16.28zm.83 8.36a8 8 0 0 1-11 6.08 3.26 3.26 0 0 0-1.25-.26 3.43 3.43 0 0 0-.56.05l-2.82.57.57-2.82a3.09 3.09 0 0 0-.21-1.81 8 8 0 0 1 6.08-11 8 8 0 0 1 9.19 9.19z"></path>
            </svg>
          </div>
          <span className="text-white font-semibold text-lg leading-none flex items-center">
            How May I Help You?
          </span>
        </div>
        <div className="flex items-center gap-2">
          {/* Expand/Shrink Button */}
          <button
            onClick={() => setIsExpanded(prev => !prev)}
            className="text-white/80 hover:text-white transition"
            title={isExpanded ? "Shrink" : "Expand"}
            aria-label={isExpanded ? "Shrink chat" : "Expand chat"}
          >
            {isExpanded ? (
              <svg className="w-6 h-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path strokeLinecap="round" strokeLinejoin="round" d="M6 9l6 6 6-6" />
              </svg>
            ) : (
              <svg className="w-6 h-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path strokeLinecap="round" strokeLinejoin="round" d="M18 15l-6-6-6 6" />
              </svg>
            )}
          </button>

          {/* Close Button */}
          <svg
            onClick={closeChat}
            className="w-6 h-6 text-white/80 hover:text-white cursor-pointer transition"
            fill="currentColor"
            viewBox="0 0 20 20"
          >
            <path d="M10 1.6a8.4 8.4 0 1 0 0 16.8 8.4 8.4 0 0 0 0-16.8zm4.789 11.461L13.06 14.79 10 11.729l-3.061 3.06L5.21 13.06 8.272 10 5.211 6.939 6.94 5.211 10 8.271l3.061-3.061 1.729 1.729L11.728 10l3.061 3.061z"></path>
          </svg>
        </div>
      </div>

      {/* Messages */}
      <div className={`flex flex-col ${isExpanded ? "h-[600px]" : "h-64"} overflow-y-auto p-4 space-y-3 scrollbar-thin scrollbar-thumb-blue-300 scrollbar-track-transparent transition-all duration-300`}>
        {messages.map((message, index) => (
          <div
            key={index}
            className={`relative max-w-[90%] px-4 py-2 text-justify rounded-2xl text-sm shadow-sm ${message.sender === "user"
              ? "bg-gradient-to-r from-blue-500 to-indigo-500 text-white self-end rounded-br-none"
              : "bg-gray-100 text-gray-800 self-start rounded-bl-none"
              }`}
          >
            {message.text}
          </div>
        ))}
        {loading && <Loader />}
        <div ref={messageEndRef} />
      </div>

      {/* Input */}
      <div className="w-full p-4 bg-white border-t border-gray-200">
        <div className="relative flex items-center">
          <input
            type="text"
            placeholder="Ask your question..."
            value={input}
            onChange={(e) => setInput(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") sendMessage();
            }}
            className="w-full rounded-full border border-gray-300 bg-gray-50 px-4 py-2 pr-12 text-gray-800 shadow-sm outline-none transition focus:border-blue-500 focus:ring-2 focus:ring-blue-200"
          />
          <button
            onClick={sendMessage}
            className="absolute right-2 flex items-center justify-center w-8 h-8 rounded-full bg-blue-500 hover:bg-blue-600 transition text-white"
          >
            ➤
          </button>
        </div>
      </div>
    </div>
  );

};

export default Bot;
